/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 模板类型
 */
let EnumPowerType = {
	Normal             : new EnumItem('常规市电', 1),
	Sun               : new EnumItem('太阳能供电', 2),
	...enumMixn
}
export default EnumPowerType
